import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TradeshowForm from "@preferredMedical/Widgets/TradeshowForm/TradeshowForm";
import * as React from "react";
import { connect } from "react-redux";

const enum fields {
    backgroundColor = "backgroundColor",
    emailRecipients = "emailRecipients",
    introductoryText = "introductoryText",
    businessTypes = "businessTypes",
    referralOptions = "referralOptions",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.emailRecipients]: string;
    };
}

type Props = WidgetProps & OwnProps & ReturnType<typeof mapStateToProps>;
const mapStateToProps = (state: ApplicationState) => ({
    variantSelectionCompleted: state.pages.productDetails.variantSelectionCompleted,
    session: state.context.session,
});

const TradeshowFormWidget: React.FC<Props> = ({ session, fields }) => {
    const { backgroundColor, introductoryText, emailRecipients, businessTypes, referralOptions } = fields;

    return (
        <StyledWrapper>
            <TradeshowForm
                emailRecipients={emailRecipients}
                widgetSettings={{ backgroundColor, introductoryText, businessTypes, referralOptions }}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(TradeshowFormWidget),
    definition: {
        displayName: "Tradeshow Form",
        group: "My Account",
        fieldDefinitions: [
            {
                name: fields.backgroundColor,
                displayName: "Background Color",
                editorTemplate: "ColorPickerField",
                defaultValue: "#333333",
                fieldType: "General",
                isRequired: true,
            },
            {
                name: fields.emailRecipients,
                displayName: "Email recipients (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: fields.introductoryText,
                displayName: "Introductory Text",
                editorTemplate: "RichTextField",
                fieldType: "General",
                defaultValue:
                    "Wolf medical is the nation’s leading distributor of iv & infusion products to hospitals and pharmacies.",
                isRequired: true,
            },
            {
                name: fields.businessTypes,
                displayName: "Business Types (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue:
                    "Allergy (default selection)\n" +
                    "Anti-Aging/Wellness\n" +
                    "Chelation\n" +
                    "Compounding Pharmacy\n" +
                    "Consultant\n" +
                    "Correctional Facility\n" +
                    "Dental\n" +
                    "Dialysis Center\n" +
                    "Distributor\n" +
                    "DME/HME\n" +
                    "Education\n" +
                    "EMS\n" +
                    "Government\n" +
                    "Home Infusion\n" +
                    "Hospice\n" +
                    "Hospital/Medical Center\n" +
                    "Imaging Center\n" +
                    "Industrial\n" +
                    "Infectious Disease\n" +
                    "LTC Pharmacy\n" +
                    "Manufacturer\n" +
                    "Neurology\n" +
                    "Nursing Services\n" +
                    "Oncology\n" +
                    "Ophthalmology\n" +
                    "Other\n" +
                    "Pain Management\n" +
                    "Physician\n" +
                    "Research & Development\n" +
                    "Retail Pharmacy\n" +
                    "Rheumatology\n" +
                    "Skilled Nursing\n" +
                    "Specialty Pharmacy\n" +
                    "Surgery Center\n" +
                    "Urgent Care Center\n" +
                    "Vein & Vascular\n" +
                    "Veterinary",
                isRequired: true,
            },
            {
                name: fields.referralOptions,
                displayName: "Referral Options (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: `NICA
NHIA
NDC
VITAL CARE
IGNS`,
                isRequired: true,
            },
        ],
    },
};

export default widgetModule;
